import {RichTextEditor} from "../../../../../misc/richtext/RichTextEditor";
import {preambleToEditorHtml} from "../../../../../misc/richtext/preambleContent";

export function PreambleTab(props: {
    value: string;
    onChange(value: string): void;
}) {

    return (
        <>
            <div style={{height: 8}} />
            <RichTextEditor
                initialValue={preambleToEditorHtml(props.value)}
                onChange={props.onChange}
            />
        </>
    )
}
